<template>
    <nav class="navbar navbar-expand-lg navbar-dark shadow-sm disable-selection">

      <router-link tag="a" class="navbar-brand" :to="{name: 'home'}" v-if="!$store.getters.instanceLoaded">
        <img src="./../../assets/img/logo_mini.png" height="30" class="d-inline-block align-top" alt="Niche Guardian">
      </router-link>
      <a href="#" class="navbar-brand" v-else>
        <img src="./../../assets/img/logo_mini.png" height="30" class="d-inline-block align-top nav-logo-ml-on-mobile" alt="Niche Guardian">

      </a>

        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#ngNavbar"
                aria-controls="ngNavbar" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="ngNavbar" style="z-index: 101">
            <ul id="titles" class="navbar-nav mr-auto d-none d-lg-flex" style="max-width: 60%;">
                <li v-if="$store.getters.channelSelected" class="d-none d-xl-inline">
                    <p class="channel-title" :title="$store.getters.getActiveChannelName">
                        {{ $store.getters.getActiveChannelName }}
                    </p>
                </li>
                <li v-if="$store.getters.instanceLoaded" class="d-none d-xl-inline">
                    <div class="separator"></div>
                </li>
                <li v-if="$store.getters.instanceLoaded">
                    <p class="instance-title" :title="activeInstanceName">
                        {{ shortenedInstanceName }}
                        <span class="badge badge-danger ml-1 instance-nav-badge" v-if="$store.getters.instanceInLiveMode">
                            LIVE
                        </span>
                        <span class="badge badge-success ml-1 instance-nav-badge" v-if="$store.getters.activeInstanceData.live && $store.getters.activeInstanceData.live.isRunning && !$store.getters.activeInstanceData.live.isPaused">
                            {{ $moment().startOf('day').seconds($store.getters.getInstanceLiveElapsedSeconds).format('HH:mm:ss') }}
                        </span>
                        <span class="badge badge-warning ml-1 instance-nav-badge" v-if="$store.getters.activeInstanceData.live && !$store.getters.activeInstanceData.live.isRunning && $store.getters.activeInstanceData.live.isPaused">
                            Paused - {{ $store.getters.activeInstanceData.live.timestamp }}
                        </span>
                    </p>
                </li>
            </ul>

            <NavBarControls></NavBarControls>
        </div>
    </nav>
</template>


<script>
import { SweetModal } from 'sweet-modal-vue';
import { RepositoryFactory } from '../../repositories/RepositoryFactory';
import NavBarControls from '../children/chaptering/NavBarControls';

const ChannelRepository = RepositoryFactory.get('adminChannels');
const InstanceRepository = RepositoryFactory.get('instances');

export default {
  name: 'NavBar',
  components: { NavBarControls, SweetModal },
  data() {
    return {
      channels: {
        list: [],
      },
      selectedChannel: null,
      newInstanceName: '',
    };
  },
  mounted() {
    this.newInstanceName = this.activeInstanceName;
  },
  computed: {
	  /**
	   * Returns the instance Name of the currently active instance.
	   *
	   * @returns {string}
	   */
    activeInstanceName() {
      if (this.$store.state.instance !== null) {
	      const { title } = this.$store.state.instance;
      	if (this.$store.state.instance.title !== null) {
          return title;
        }
      	return '';
      }
      return '';
    },
	  /**
     * Returns a shortened version of the instance Name if it exceeds 40 characters.
     *
	   * @returns {default.computed.activeInstanceName|string}
	   */
    shortenedInstanceName() {
    	const instanceName = this.activeInstanceName;
    	if (instanceName !== '' && instanceName !== null) {
    		if (instanceName.length > 30) { return `${instanceName.substr(0, 30)}...`; }
    		return instanceName;
      }
    	return '';
    },
  },
};
</script>
